import script from "./ChatToolbarButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatToolbarButton.vue?vue&type=script&setup=true&lang=js"

import "./ChatToolbarButton.vue?vue&type=style&index=0&id=bf5b014c&scoped=true&lang=css"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf5b014c"]])

export default __exports__